import { Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Voucher } from 'app/models/vouchers/voucher';
import { VoucherLetterUpload } from 'app/models/vouchers/voucher-letter-upload';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { VoucherService } from 'app/services/voucher-service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';
import { exportPDF, Group } from '@progress/kendo-drawing';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';

@Component({
  selector: 'coc-voucher-letter',
  templateUrl: './coc-voucher-letter.component.html',
  styleUrls: ['./coc-voucher-letter.component.scss']
})
export class COCVoucherLetterComponent implements  OnInit {
  @ViewChild('pdf') pdf: PDFExportComponent;
  public environment = environment;
  voucher: Voucher = undefined;
  processing: boolean = false;
  processingMessage: string = "";
  mailingAddress: string = "";
  mailingCity: string = "";
  mailingState: string = "";
  mailingZip: string = "";
  phone: string = "";
  email: string = "";
  customerName: string = "";
  wellAddress: string = "";
  today: string = "";;
  letter: VoucherLetterUpload = {
    id: 0,
    letterHtml: '',
    letterType: this.voucherService.voucherCOCLetterType,
    parameterResultId: 0,
    sampleId: 0,
    voucherId: 0,
    letterContent: '',
    voucherApplicationId: 0,
    quarter: 0,
    year: 0,
    tier: 0,
    testType: '',
    testsRequired: '',
    retestId: 0,
    wellAddress: '',
    customerName: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    phone: '',
    email: '',
    voucherIdentifier: '',
    base64File: ''
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: VoucherLetterUpload,
              private dialogRef: MatDialogRef<COCVoucherLetterComponent>,
              public voucherService: VoucherService, 
              private toastr: ToastrService, 
              public oregonWellDataService: OregonWellDataService) {                
                this.letter = this.data;
  }


  ngOnInit(): void {
    let now = new Date();
    this.today = now.toLocaleString('default', { month: 'short' }) + " " + (new Date().getDate()).toString() + ", " + (new Date().getFullYear()).toString();    
    this.load();
  }

  load() {
    this.processing = true;
    this.processingMessage = "Generating";
    this.voucherService.getVoucherById(this.letter.voucherId).subscribe(
      result => {
        this.voucher = result;
        
        this.mailingAddress = this.voucher.applicantAddress ?? '';

        this.mailingCity = this.voucher.applicantCity ?? '';
        this.mailingState = this.voucher.applicantState ?? '';
        this.mailingZip = this.voucher.applicantZip ?? '';
        this.phone = this.voucher.applicantContactPhone ?? '';
        this.email = this.voucher.applicantContactEmail ?? '';
        this.customerName = this.voucher.applicantContactName ?? '';
        if(this.voucher.well != null) {
          this.wellAddress = this.voucher.well.address1 ?? '';
          if(this.voucher.well.city != null && this.voucher.well.city != "") {
            this.wellAddress += " " + this.voucher.well.city;
          }
          if(this.voucher.well.state != null && this.voucher.well.state != "") {
            this.wellAddress += " " + this.voucher.well.state;
          }
          if(this.voucher.well.zip != null && this.voucher.well.zip != "") {
            this.wellAddress += " " + this.voucher.well.zip;
          }

        }
        this.processingMessage = "";
        this.processing = false;
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );
  }

  onSubmit() {   

    if(this.letter.testsRequired == undefined || this.letter.testsRequired == null || this.letter.testsRequired == "") {
      this.toastr.error("Tests Required is required");
      return;
    }
    if(this.letter.testType == undefined || this.letter.testType == null || this.letter.testType == "") {
      this.toastr.error("Tests Type is required");
      return;
    }
    if(this.letter.testType != undefined && this.letter.testType != null && this.letter.testType == "Quarterly" && (this.letter.quarter == undefined || this.letter.quarter == null || this.letter.quarter == 0)) {
      this.toastr.error("Quarter is required");
      return;
    }
    
    this.letter.letterHtml = this.oregonWellDataService.stripHtmlComments(document.getElementById('voucherLetterPdf').innerHTML);
    
    this.processing = true;
    this.processingMessage = "Saving Letter";
    this.letter.voucherId = this.voucher.id;
    this.voucherService.uploadLetter(this.letter).subscribe(
      result => {
        this.processingMessage = "";
        this.processing = false;
        this.toastr.success("Voucher COC Letter saved");
        this.dialogRef.close();
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
        this.toastr.error(error.message);
      }
    );
  }

  onSubmitKendo() {
    if(this.letter.testsRequired == undefined || this.letter.testsRequired == null || this.letter.testsRequired == "") {
      this.toastr.error("Tests Required is required");
      return;
    }
    if(this.letter.testType == undefined || this.letter.testType == null || this.letter.testType == "") {
      this.toastr.error("Tests Type is required");
      return;
    }
    if(this.letter.testType != undefined && this.letter.testType != null && this.letter.testType == "Quarterly" && (this.letter.quarter == undefined || this.letter.quarter == null || this.letter.quarter == 0)) {
      this.toastr.error("Quarter is required");
      return;
    }
    
    this.letter.letterHtml = '';
    
     this.pdf.export().then((group: Group) => exportPDF(group)).then((dataUri) => {   
          const base64  = dataUri.replace('data:application/pdf;base64,', '');
          this.letter.letterHtml = '';
          this.letter.base64File = base64;
          this.processing = true;
          this.processingMessage = "Saving Letter";
          this.letter.voucherId = this.voucher.id;
          this.voucherService.uploadLetter(this.letter).subscribe(
            result => {
              this.processingMessage = "";
              this.processing = false;
              this.toastr.success("Voucher COC Letter saved");
              this.dialogRef.close();
            },
            error => {
              this.processing = false;
              this.processingMessage = "";
              this.toastr.error(error.message);
            }
          );
       });
  }
}